module.exports = __webpack_public_path__ + "img/img0.83d08a30.jpg";